import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { AdminService } from "../../../services/api/admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerActivateEffects {
	activate = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.consumer.activate),
			switchMap((action) =>
				this.mpAdminService.activateConsumer(action.id, action.currencyCode, action.taxExempt).pipe(
					map(() => MpAdminActions.consumer.activateSuccess({ id: action.id })),
					catchError((error) =>
						of(MpAdminActions.consumer.activateFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private mpAdminService: AdminService
	) {}
}
